import { thousandSeparated } from '../../lib/formatting.js';
import logarithmicFormatter from './logarithmicFormatter.js';

export default {
    calculateSliderValue(price) {
        return logarithmicFormatter.fromRealToLogValue(price);
    },

    formatFilterValue(price) {
        return logarithmicFormatter.fromLogToRealValue(price);
    },

    formatStartLabel(price) {
        return thousandSeparated(logarithmicFormatter.fromLogToRealValue(price));
    },

    formatEndLabel(price) {
        return `${thousandSeparated(logarithmicFormatter.fromLogToRealValue(price))} kr`;
    },
};
